var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"privacy-policy"},[_c('div',{staticClass:"content"},[_c('vue-markdown',{attrs:{"linkify":false}},[_vm._v(_vm._s(_vm.content))])],1),_c('Footer',{staticClass:"footer",attrs:{"white":true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }